import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, APP_BOOTSTRAP_LISTENER, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { AuthStore } from './core/auth/store/auth.store';
import { authInterceptor } from './core/auth/interceptor/auth.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { LOOKUP_HANDLERS_PROVIDERS } from './shared/store/lookups/lookup-handlers.providers';
import { SpanishPaginatorIntl } from './shared/utils/ui/material/spanish-paginator';
import { DATE_PROVIDERS } from './shared/utils/date-providers';


// Date formats moved to specific route providers to reduce initial bundle


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },

    { provide: APP_BOOTSTRAP_LISTENER, multi: true, useFactory: hidrateFactory, deps: [AuthStore] },

    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    ...DATE_PROVIDERS,

    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor])
    ),

    ...LOOKUP_HANDLERS_PROVIDERS,

    { provide: MatPaginatorIntl, useClass: SpanishPaginatorIntl },
  ]
};


function hidrateFactory(store: AuthStore) {

  return () => {
    if (!store.token()) return;
    store.hydrate();
  };
}
